module.exports = __webpack_public_path__ + "media/icons/logo-360TissueNext-8cbc4c4b.svg";